export default "__VITE_ASSET__B04D7zxM__"